import { render, staticRenderFns } from "./ThyroidTable.vue?vue&type=template&id=06bf140b&scoped=true&"
import script from "./ThyroidTable.vue?vue&type=script&lang=js&"
export * from "./ThyroidTable.vue?vue&type=script&lang=js&"
import style0 from "./ThyroidTable.vue?vue&type=style&index=0&id=06bf140b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06bf140b",
  null
  
)

export default component.exports